/**
 * Validates and sanitizes a URL path to prevent open redirect vulnerabilities.
 * Only allows relative paths that start with '/' and do not contain protocol schemes.
 */
export function sanitizeInternalPath(path) {
  if (!path || typeof path !== 'string') {
    return null;
  }

  const trimmedPath = path.trim();

  if (!trimmedPath.startsWith('/')) {
    return null;
  }

  if (trimmedPath.startsWith('//')) {
    return null;
  }

  const hasProtocol = /^[a-zA-Z][a-zA-Z0-9+.-]*:/i.test(trimmedPath);
  if (hasProtocol) {
    return null;
  }

  try {
    const decodedPath = decodeURIComponent(trimmedPath);

    if (decodedPath.startsWith('//')) {
      return null;
    }

    const hasDecodedProtocol = /^[a-zA-Z][a-zA-Z0-9+.-]*:/i.test(decodedPath);
    if (hasDecodedProtocol) {
      return null;
    }
  } catch (e) {
    return null;
  }

  return trimmedPath;
}

/**
 * Creates a safe internal URL by combining origin with a sanitized path.
 */
export function createSafeInternalUrl(origin, path) {
  const sanitizedPath = sanitizeInternalPath(path);
  if (!sanitizedPath) {
    return null;
  }
  return origin + sanitizedPath;
}
